<template>
    <div>
      <div v-for="item in followList">
        <div v-if="item.type !=2">
        {{item.create_time}}  {{item.creator.nameZh}}({{item.creator.nameEn}})  <span v-if="item.type != 1">{{item.state_desc}}</span><span v-if="item.type == 1">催单成功</span>
        <div v-if="item.type == 1">
          催单描述：{{item.desc}}
        </div>
        <span v-else-if="item.transferor.id"> 受理人: <span style="color:#E6A23C;">{{item.transferor.nameZh}}</span> 状态: <span style="color:#E6A23C;"> {{item.after_state
          }} </span> </span>
        <span v-else-if="item.before_state && item.before_state == item.after_state"> </span>
        <span v-else-if="!item.before_state"> 状态为 <span style="color:#E6A23C;"> {{item.after_state
          }} </span> </span>
        <span v-else> 从 <span style="color:#E6A23C;">{{item.before_state}}</span> 更新为 <span style="color:#E6A23C;"> {{item.after_state
          }} </span> </span>
        <div v-if="item.note&& item.type != 1">备注：{{item.note}}</div>
          <div v-if="item.state_desc === '验收工单' && validate_desc">验证描述:{{validate_desc}}</div>
        </div>
      </div>
    </div>
</template>
<script>
import { Editor } from "@/components/index.js";
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"

import {
  getDevOpsSpaceProducerListApi, getDevOpsSpaceReminderWorkOrderListlApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {Editor},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    followList:{
      type:Object,
      default:{},
    }
  },
  data() {
    return {
      form: {
        priority: 'P1',
        reviewer: {},
        re_details:'',
        demandDesc: '',
        reviewerId: '',
        progressRate: '',
        name:'',
        pmId: '',
      },

      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        projectId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        systemId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demanderId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        pmId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        priority: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        expectFinishDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        demandDesc: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reviewerId: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate:{
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur"
        },
        prdLink: {
          required: this.formInfo.id,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
      },
      validate_desc:'',
    };
  },
  created() {
    this.followList.forEach(item=>{
      if(item.type == 2 && item.desc){
        this.validate_desc = item.desc;
      }
    })
  },
  async mounted() {
    const { id = '', status = '',  name = '', next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id, status, name}
    this.$set(this.form, 'username', username)
    this.username = username;
    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      // this.getReminderWorkOrderListlApi();
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    newTitle(){
      return '跟单记录 - 【'+this.formInfo.id+'】'+this.formInfo.title;
    },
  },
  methods: {
    async getReminderWorkOrderListlApi() {
      await getDevOpsSpaceReminderWorkOrderListlApi({workId: this.formInfo.id, type: '1'}).then((res) => {
        this.followList = res.data;
      })
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}
.follow_list {
  max-height: 85vh;
  overflow-y: auto;
  white-space: pre-wrap;
  /* background: #f1fbec; */
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  line-height: 24px;
  padding: 10px;
}
.el-drawer__header {
  font-size: 14px;
}

</style>
